var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSearchIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 17,
  height: 17,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.334 14c1.538 0 2.952-.53 4.08-1.407l3.664 3.664 1.178-1.179-3.663-3.663A6.626 6.626 0 0 0 14 7.333 6.674 6.674 0 0 0 7.334.667 6.674 6.674 0 0 0 .667 7.333 6.674 6.674 0 0 0 7.334 14Zm0-11.667c2.757 0 5 2.243 5 5 0 2.758-2.243 5-5 5-2.758 0-5-2.242-5-5 0-2.757 2.242-5 5-5Z",
  fill: "#98A4AF"
})));
export { SvgSearchIcon as ReactComponent };
export default __webpack_public_path__ + "dd1285204865dd366960084a41ef603d.svg";